import { render, staticRenderFns } from "./you_like.vue?vue&type=template&id=3cb297d8&scoped=true&"
import script from "./you_like.vue?vue&type=script&lang=js&"
export * from "./you_like.vue?vue&type=script&lang=js&"
import style0 from "./you_like.vue?vue&type=style&index=0&id=3cb297d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb297d8",
  null
  
)

export default component.exports